import React, { useState } from 'react';
import {
  Button,
  Typography,
  TextField,
  Box,
} from '@mui/material';
import emailjs from 'emailjs-com';

emailjs.init("Jp7AgDg3B-Lw0bCCR"); 

const SubscribeForm = () => {
  const [result, setResult] = useState('');

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      // Check if the file size is greater than 500 KB
      if (selectedFile.size > 500000) {
        alert('The file is too large. Please select a file that is 500 KB or smaller.');
        event.target.value = ""; // Clear the input
      }
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending...");

    const form = event.target;
    const formData = new FormData(form);
    const file = formData.get("attachment");

    if (!file) {
      setResult("Please select a file.");
      return;
    }

    const reader = new FileReader();

    reader.onload = async () => {
      const base64File = reader.result.split(",")[1]; // Strip off "data:*/*;base64,"

      const templateParams = {
        from_name: formData.get("fname") + " " + formData.get("sname"),
        first_name: formData.get("fname"),
        reply_to: formData.get("email"),
        organisation: formData.get("org"),
        title: formData.get("title"), // Capturing the abstract title from the form
        attachment: base64File,
        filename: file.name
      };

      try {
        const response = await emailjs.send(
          "service_xucnxl7",
          "template_unomzh8",
          templateParams
        );

        if (response.status === 200) {
          setResult("✅ Success! Form submitted.");
          form.reset();
        } else {
          setResult("❌ Error submitting form. Please try again.");
        }
      } catch (error) {
        console.error("EmailJS Error:", error);
        setResult("⚠️ Network error. Please try again.");
      }
    };

    reader.readAsDataURL(file);
  };

  return (
    <Box
      className="rounded-xl bg-white border-light-orange"
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        p: 4,
        borderRadius: 2,
        bgcolor: 'white',
        boxShadow: 2,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
          width: '100%',
        }}
      >
        <Button
          variant="outlined"
          color="secondary"
          fontWeight="bold"
          sx={{ bgcolor: '#EB9A3E', width: '200px', height: '60px' }}
          href="/conference/abstractTemplateAMMET2025.docx"
          download
        >
          Abstract Template
        </Button>

        <TextField
          required
          name="fname"
          label="First Name"
          variant="outlined"
          sx={{ flex: '1 1 300px' }}
        />
        <TextField
          required
          name="sname"
          label="Surname"
          variant="outlined"
          sx={{ flex: '1 1 300px' }}
        />
        <TextField
          required
          name="email"
          label="Email"
          variant="outlined"
          sx={{ flex: '1 1 300px' }}
        />
        <TextField
          required
          name="org"
          label="Organisation"
          variant="outlined"
          sx={{ flex: '1 1 300px' }}
        />
        <TextField
          required
          name="title"
          label="Abstract Title"
          variant="outlined"
          sx={{ flex: '1 1 300px' }}
        />


        {/* LARGER FILE INPUT */}
        <Box
          sx={{
            width: '100%',
            border: '2px solid #000',
            borderRadius: '4px',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Typography variant="body1">Upload File* (maximum file size 500 KB)</Typography>
          <input
            required
            type="file"
            name="attachment"
            onChange={handleFileChange}
            accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            style={{
              padding: '12px',
              border: 'none',
              fontSize: '1rem',
            }}
          />
        </Box>

        {/* UPDATED SUBMIT BUTTON */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          sx={{
            height: '60px',
            fontSize: '1.1rem',
            fontWeight: 'bold',
          }}
        >
          Submit
        </Button>

        <Typography variant="body2" color="error" sx={{ width: '100%' }}>
          {result}
        </Typography>
      </form>
    </Box>
  );
};

export default SubscribeForm;
